import React from "react";
import { Box, Button, Grid } from "@mui/material";
import PressReleaseCard from "../../pressReleases_comps/PressReleaseCard";
import pressReleases from "../../../assets/data/pressReleases";

function PressReleaseSection() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "70vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 4,
      }}
    >
      <Grid
        container
        rowSpacing={5}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{ mx: 5, my: 3 }}
      >
        {pressReleases.map((pressRelease) => (
          <Grid size={6} key={pressRelease}>
            <PressReleaseCard pressRelease={pressRelease} />
          </Grid>
        ))}
      </Grid>
      <Box sx={{ my: 4 }}>
        <Button
          variant="outlined"
          sx={{ color: "#000", borderColor: "#55d6aa" }}
        >
          More Press Releases
        </Button>
      </Box>
    </Box>
  );
}

export default PressReleaseSection;
